import { render, staticRenderFns } from "./editProductLabelModel.vue?vue&type=template&id=2eb83808"
import script from "./editProductLabelModel.vue?vue&type=script&lang=js"
export * from "./editProductLabelModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports